import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    const scrollToAnchor = () => document.getElementById(id)?.scrollIntoView({ block: "start" });
    const frame = window.requestAnimationFrame(scrollToAnchor);
    const timer = window.setTimeout(scrollToAnchor, 250);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [pathname, hash]);

  return null;
}